

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"nonzero","d":"M14.24.73c4.91 0 7.01 2.1 7.01 7.01v6.52c0 4.91-2.1 7.01-7.01 7.01h-.13c-4.44 0-6.58-1.75-6.95-5.67-.04-.41.26-.78.68-.82.4-.04.78.27.82.68.29 3.14 1.77 4.31 5.46 4.31h.13c4.07 0 5.51-1.44 5.51-5.51V7.74c0-4.07-1.44-5.51-5.51-5.51h-.13c-3.71 0-5.19 1.19-5.46 4.39-.05.41-.4.72-.82.68a.751.751 0 0 1-.69-.81C7.49 2.51 9.64.73 14.11.73h.13ZM5.38 7.12c.29.29.29.77 0 1.06l-2.071 2.07h10.69c.41 0 .75.34.75.75s-.34.75-.75.75H3.31l2.07 2.07c.29.29.29.77 0 1.06-.14.15-.34.22-.53.22s-.38-.07-.53-.22L.97 11.53a.754.754 0 0 1 0-1.06l3.35-3.35c.29-.29.77-.29 1.06 0Z"}, []), "\n"]);
};

        